import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from "../../../../../../../../core/shared/widget/widget-data";
import {FilterCriteria} from "../../../../../../../../core/shared/filter/api/filter.criteria";
import {WidgetFactory} from "../../../../../../../../core/shared/widget/service/widget.factory";
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from "../../../../../../../../core/shared/helper/widget-function-call-back-create";

@Component({
    selector: 'bm-camt-import-config-document-types',
    templateUrl: 'camt-import-config-document-types.component.html',
    standalone: false
})
export class CamtImportConfigDocumentTypesComponent implements OnInit, OnChanges, OnDestroy {

    initialized: boolean;

    @Input() configId: number;

    documentTypesWidgetData: WidgetData;

    ngOnInit(): void {
        this.initComponent();
    }

    initComponent() {
        this.refreshComponent();
    }

    refreshComponent() {
        const filterCriteria = FilterCriteria.create(
            'e.creditorCamtImportConfigId',
            FilterCriteria.cOperatorEqual,
            this.configId
        );

        this.documentTypesWidgetData = WidgetFactory.createWidgetTableEntityBasicQl(
            'bm.creditor.camt.import.config.document.types',
            'Zugeordnete Dokumenttypen',
            'bm.CreditorCamtImportConfigDocumentType',
            [filterCriteria]
        );

        const fields: WidgetToolbarCreateInterface[] = [{
            fieldName: 'creditorCamtImportConfigDtoId',
            fieldValue: this.configId
        }];
        this.documentTypesWidgetData.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);

        this.initialized = true;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        if (changes["configId"]) {
            this.refreshComponent();
        }
    }

    ngOnDestroy(): void {
    }
}
